const initialState = {
    call_history: [],
    activeCalls: [],
    isReadingCallHistory: false,
    isReadingActiveCalls: false,
    allMarked: false,

    recent_calls: [],
    isReadingRecentCalls: false,
    recent_call: null,
    isReadingRecentCall: false,
    call_history_details: null,
    isReadingCallHistoryDetails: false,

    isUpdatingCallResults: false
}

export default initialState;
